import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Simulador Operativo — Core de Crédito" },
      {
        name: "description",
        content:
          "Acceso al simulador operativo de crédito y control de pagos para SOFOM en México.",
      },
      { property: "og:title", content: "Simulador Operativo — Core de Crédito" },
      {
        property: "og:description",
        content:
          "Acceso al simulador operativo de crédito y control de pagos para SOFOM en México.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  beforeLoad: () => {
    throw redirect({ to: "/operativo" });
  },
});
